export enum Integrations {
    ZAPIER = "Zapier",
    STRIPE = "Stripe",
    GOOGLE_CALENDAR = "Google Calendar",
    ZOOM = "Zoom"
}

export type Integration = {
    id: string
    logo?: string
    name: string
    description?: string
    client_secret?: string
    connected_account_id?: string
    tenant_id?: string
    password?: string
    business?: {
        email: string,
        name: string,
    },
    connect_url?: string
    disconnect_url?: string
    category?: {
        id: string
    }
    locations?: {
        id: string
        name: string
        integration_id: string
        business: {
            email: string,
            name: string,
        },
        connected_account_id: string,
    }[]
    oauth_code?: string
    deleted_at?: string
    zoom_enabled?: boolean
}

export type IntegrationCategory = {
    id: string
    name: string
}

export type IntegrationDTO = {
    categoryId: string
    categoryName?: string
    readOnly?: boolean
    deletedAt?: string
    id: string
    imageUrl?: string
    name: string
} 

export function mapFromIntegrationDTO(dto: IntegrationDTO) {
    return {
        id: dto.id,
        logo: dto.imageUrl,
        deleted_at: dto.deletedAt,
        category: {
            id: dto.categoryId
        },
        name: dto.name
    } as Integration
}